import React, { useCallback, useMemo, VFC } from 'react';
import DefaultImage from '~/images/admin/default.png';
import { Person } from '~/src/core/People/types';
import PersonInfo from './PersonInfo';
import Tab from '@material-ui/core/Tab';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  tab: {
    alignItems: 'baseline',
    padding: 0,
    minWidth: 140,
    opacity: 1,
    [theme.breakpoints.down('xs')]: {
      minWidth: 100,
    },
  },
  tabWrapper: {
    height: '100%',
    justifyContent: 'flex-start',
  },
}));

interface Props {
  person: Person;
  loaded: boolean;
  onChangeTab: (id: number) => void;
  index: number;
}

const PersonTab: VFC<Props> = ({ person, loaded, onChangeTab, index }) => {
  const classes = useStyles();

  const imageUrl = useMemo(
    () => (loaded ? person.imageUrl || DefaultImage : null),
    [loaded, person],
  );
  const handleMouseEnter = useCallback(() => {
    onChangeTab(index);
  }, [onChangeTab, index]);

  return (
    <Tab
      id={`people-tab-${person.id}`}
      value={person.id}
      label={
        <PersonInfo
          loaded={loaded}
          lastName={person.lastName}
          firstName={person.firstName}
          role={person.role}
          imageUrl={imageUrl}
          CardProps={{ onMouseEnter: handleMouseEnter }}
        />
      }
      component="div"
      classes={{
        root: classes.tab,
        wrapper: classes.tabWrapper,
      }}
    />
  );
};

export default PersonTab;
